import { Components } from "appworks/components/components";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { Contract } from "appworks/utils/contracts/contract";
import { Filter } from "pixi.js";
import { LinesComponent } from "slotworks/components/lines/lines-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";
import { TGRShowWinLines } from "states/winnings/tgr-show-win-lines";

export class DMFShowWinLines extends TGRShowWinLines {

    public static WILD_SYMBOL: string = "W";

    protected highlightWin(result: SymbolWinResult, color: number) {
        const symbolsToAnimate = this.setupSymbolsToAnimate(result);

        // Show line
        if (result instanceof LineResult) {
            const reverse = result.positions[0].x !== 0;
            Components.get(LinesComponent)?.highlight(result.line, reverse);

            if (!this.bigWinPending) {
                Services.sound.event(SoundEvent.win_line_N, result.line.toString());
            }

            const isWild: boolean = result.symbols.indexOf(DMFShowWinLines.WILD_SYMBOL) > -1;
            if (isWild) {
                Services.sound.customEvent("highlight_win_wild");
            } else {
                Services.sound.customEvent(`highlight_win_nowild_${result.symbolType}`);
            }
        }

        // Tint and filter effects
        const filters: Filter[] = this.getFilterEffects(color);
        if (this.config.enableLineEffects) {
            if (result instanceof LineResult) {
                if (filters.length) {
                    Components.get(LinesComponent)?.filter(result.line, filters);
                } else {
                    Components.get(LinesComponent)?.tint(result.line, color);
                }
            }
        }
        if (this.config.enableBehaviourEffects) {
            Components.get(AbstractMatrixComponent).setSymbolEffects(symbolsToAnimate, color, filters, this.config.applyEffectsToSymbolBehaviours);
        }

        const highlightSymbols = Components.get(AbstractMatrixComponent).highlightSymbols(symbolsToAnimate, result, !this.config.continuousHighlight);

        if (this.config.perLineDelay) {
            highlightSymbols.execute();
            return Contract.getTimeoutContract(this.config.perLineDelay);
        }

        return highlightSymbols;
    }
}
